import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { PermissionsService } from '@core/services/permissions.service';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class CanLoadAppGuard implements CanLoad {
    constructor(private permissionsService: PermissionsService) {}

    canLoad(
        route: Route,
        segments: UrlSegment[]
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.permissionsService.isPermissionsReceived.pipe(
            filter((isReceived: boolean) => isReceived)
        );
    }
}
